export function sanitizeNotes(notes: string) {
  return notes?.replace(/<[^>]+\/?>/gm, ' ');
}
